/**
 * Script simple para debuggear categorías
 */

export const debugCategories = async () => {
  try {
    console.log('🔍 Debuggeando categorías...');
    
    // Verificar window.auth
    if (!window.auth) {
      console.error('❌ window.auth no disponible');
      return;
    }

    const { getAuth } = window.auth;
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      console.error('❌ Usuario no autenticado');
      return;
    }

    console.log('✅ Usuario:', user.uid);

    // Verificar Firebase directamente
    const { getFirestore, collection, query, orderBy, getDocs } = window.auth;
    const db = getFirestore();
    
    console.log('✅ Firebase inicializado');

    // Consultar categorías directamente
    const categoriesRef = collection(db, 'users', user.uid, 'categories');
    console.log('✅ Referencia a categorías creada');
    
    const q = query(categoriesRef, orderBy('name'));
    console.log('✅ Query creada');
    
    const snapshot = await getDocs(q);
    console.log('✅ Snapshot obtenido, docs:', snapshot.docs.length);
    
    const categories = snapshot.docs.map((doc: any) => ({
      id: doc.id,
      data: doc.data()
    }));
    
    console.log('📋 Categorías encontradas:', categories);
    
    // Probar el servicio optimizado
    console.log('🔧 Probando servicio optimizado...');
    const optimizedService = (await import('../services/optimizedInventoryService')).default;
    const serviceCategories = await optimizedService.getCategories();
    console.log('📊 Categorías del servicio:', serviceCategories);

  } catch (error) {
    console.error('❌ Error:', error);
  }
};

// Hacer disponible en consola
if (typeof window !== 'undefined') {
  (window as any).debugCategories = debugCategories;
}
